module.exports = __webpack_public_path__ + "media/images/athletes/4317-1ce4e772bef4d1a831ced9f89e9d37a2.png";